import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService, TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import {
  FilterAsnData,
  FilterSPoData,
} from '../../../../models/filter-shipment-data';
import { DatePipe } from '@angular/common';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UpluadDocumentsASN } from '../../../../models/upload-documents';
import { environment } from '../../../../../environments/environment';
import { ShipmentAsn, ShipmentAsnSchedule } from '../../../../models/shipment-asn-schedul';
import { NavigationExtras, Router } from '@angular/router';
import { jsPDF } from 'jspdf';
import * as QRCode from 'qrcode';
import { ShipmentSearchDTO } from '../../../../models/shipmentSearchDTO';

interface Column {
  field: string;
}
interface ASNDetail {
  invoice:string;
  packing_type:string;
  total_number:string;
  total_net_weight:string;
  total_gross_weight:string;
  driver:string;
  vehicle:string;
  deliver_from:string;
  deliver_to:string;
  route:string;
  expected_delivery_date:string;
}

@Component({
  selector: 'app-shipment',
  templateUrl: './shipment.component.html',
  styleUrl: './shipment.component.scss',
})
export class ShipmentComponent implements OnInit {
  @ViewChild('tt') tt?: TreeTable;
  fileTemplate: any; // Define the fileTemplate property
  file: any; // Define the file property
  visible: boolean = false;
  shipmentASNList?: any[];
  mappedData: any[] = [];
  files!: TreeNode[];
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  cols!: Column[];
  selectedASN: any[] = [];
  selectedASNForPdf!: ASNDetail;
  cols2: any[] = [];
  cols3: any[] = [];
  selectedASNScheduleDeliveries: any[] = [];
  public isFileUploaded: boolean = false;

  companyCode: string = '';
  plant: string = '';
  docType: string = '';
  docCat: string = '';
  poAgreementNo: string = '';
  vendorCode: string = '';
  shipmentNo: string = '';
  status: string = '';
  documentDate: Date | undefined;
  shipmentDeliverFrom: string = '';
  shipmentDeliverTo: string = '';
  selectedASNNO: string = '';
  plantNo:string=''
  vendor:string=''
  invoice:string=''
  invoice_callan_no:string=''
  invoiceFileUrl: string = '';
  eWayBillFileUrl: string = '';
  iRNBillFileUrl: string = '';

  filterPoData!: FilterSPoData;
  filterAsnData!: FilterAsnData;

  isContentVisible = false;
  sidebarVisible2: boolean = false;

  invoiceFile: File | null = null;
  eWayBillFile: File | null = null;
  iRNBillFile: File | null = null;
  shipmentASN: string = '';

  upluadDocumentsASN: UpluadDocumentsASN = {};

  shipmentAsnScheduleDto?:ShipmentAsnSchedule
  shipmentAsnScheduleList:ShipmentAsnSchedule[] = []

  shipmentAsnMain:ShipmentAsn
  isLoading: boolean = false;
  shipmentSearchDTO?:ShipmentSearchDTO
  // // Demo Data
  // dispatchDateTime: Date = new Date('2024-06-15T10:00:00');
  // expectedDeliveryDateTime: Date = new Date('2024-06-16T10:00:00');
  // currentDate: Date = new Date();
  // // Progress variables
  // progress: number = 0; // Percentage of progress
  // progressBarColor: string = ''; // Color of progress bar
  // truckIconColor: string = ''; // Color of truck icon
  // statusText: string = ''; // Text to display below the progress bar
  // truckIcon: string = ''; // Icon variable based on status

  constructor(
    private shipmentsASNList: VendorTsService,
    private datePipe: DatePipe,
    private shipmentASNService: ShipmentASN,
    public messageService: MessageService,
    private fb: FormBuilder,
    private vendorService: VendorTsService,
    private router: Router
  ) {
    this.filterPoData = new FilterSPoData();
    this.filterAsnData = new FilterAsnData();
    this.shipmentAsnMain = new ShipmentAsn()
    this.shipmentSearchDTO = new ShipmentSearchDTO()
  }

  uploadDocuments!: FormGroup;

  ngOnInit() {
    this.uploadDocuments = this.fb.group({
      asn_no: [''],
      invoice_document: [''],
      e_way_bill_document: [''],
      irn_document: [''],
    });
    this.fetchData();
    this.initializeColumns();

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
      this.shipmentASN = selectedNo;
      this.fetchData().then(() => {
        history.replaceState({ ...history.state, selectedNo: null }, '');
      });
    }
  }

  showDialog() {
    this.visible = true;
  }




  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.fetchData()
  }
  async fetchData() {
    try {
      let data={
        page:this.currentPage,
        limit:this.limit,
        shipment_search_dto:this.shipmentSearchDTO
        }
        this.isLoading=true
      await this.shipmentsASNList
        .getShipmentASNList(data)
        .then((res) => {
          this.isLoading=false
          this.shipmentASNList = res.message.asn_list;
          this.totalRecords = res.message.total_shipment
          if (this.shipmentASNList !== undefined) {
            this.mappedData = this.shipmentASNList.map(
              (shipment: any, index: any) => {
                const sortedScheduleDeliveries =
                  shipment.scheduleDeilveries.sort((a: any, b: any) => {
                    const partsA = a.itemNo.split('_').map(Number);
                    const partsB = b.itemNo.split('_').map(Number);

                    if (partsA[0] !== partsB[0]) {
                      return partsA[0] - partsB[0];
                    }
                    return partsA[1] - partsB[1];
                  });
                return {
                  key: `parent_${index}`,
                  data: {
                    shipmentno: shipment.shipmentNo,
                    plant: "",
                    pono: shipment.asn_status,
                    packing_type: shipment.packing_type,
                    total_gross_weight: shipment.total_gross_weight,
                    total_net_weight: shipment.total_net_weight,
                    total_number: shipment.total_number,
                    expected_delivery_date: this.formatDate(
                      shipment.expected_delivery_date
                    ),
                    dispatch_date: this.formatDate(shipment.dispatch_date),
                    disDate: this.calculateHoursDifference(
                      shipment.dispatch_date
                    ),
                    invoice: shipment.invoice,
                    route: shipment.route,
                    driver: shipment.driver,
                    vehicle: shipment.vehicle,
                    position: "",
                    invoice_document: shipment.invoice_document,
                    e_way_bill_document: shipment.e_way_bill_document,
                    irn_document: shipment.irn_document,
                  },
                  children: sortedScheduleDeliveries.map(
                    (shipment_data: any, childIndex: any, array: any) => {
                      // let batchNo;
                      // let batchQuantity;
                      // shipment_data.batch.forEach((element: any) => {
                      //   batchNo = element.batch_no;
                      //   batchQuantity = element.actual_quantity;
                      // });
                      return {
                        key: `child_${index}_${childIndex}`,
                        data: {
                          shipmentno: shipment_data.plant,
                          plant: shipment_data.poagreementNo,
                          pono: this.formatDate(shipment_data.shipmentDate),
                          shipmentdate: shipment_data.name,
                          vcode: shipment_data.itemNo,
                          name: shipment_data.quantity,
                          batchNo: shipment_data.batch_no,
                          quantity: shipment_data.actual_quantity,
                          status: shipment_data.uom,
                          material_code: shipment_data.material_code,
                          po_line_item: shipment_data.po_line_item,
                          description_of_material: shipment_data.description_of_material,
                        },
                      };
                    }
                  ),
                };
              }
            );
          }
        })
        .catch((error) => {
          this.isLoading=false
          console.log(error);
        });

      if (this.shipmentASN) {
        this.mappedData = this.mappedData.filter(
          (data) => data.data.shipmentno === this.shipmentASN
        );
      }
    } catch (error) {
      this.isLoading=false
      console.error('Error fetching data:', error);
    }
  }

  calculateHoursDifference(dispatch_date: Date | undefined) {
    if (!dispatch_date) return '';

    const dispatchDate = new Date(dispatch_date);
    const currentDate = new Date();

    const differenceInMillis = dispatchDate.getTime() - currentDate.getTime();
    const differenceInHours = differenceInMillis / (1000 * 3600);

    return differenceInHours.toFixed(2);
  }

  // formatDate(dateString: string) {
  //   if (!dateString) return '';
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
  //   const year = date.getFullYear();
  //   const formattedDate = `${day}.${month}.${year}`;
  //   return formattedDate;
  // }
  formatDate(dateString: string) {
    if (!dateString) return '';

    const date = new Date(dateString);

    // Extract date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Construct ISO string format 'YYYY-MM-DDTHH:mm:ss'
    const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    return isoDateString;
  }


  initializeColumns() {
    this.cols = [
      { field: 'position' },
      { field: 'pono' },
      { field: 'shipmentno' },
      { field: 'invoice' },
      { field: 'packing_type' },
      { field: 'total_number' },
      { field: 'total_net_weight' },
      { field: 'total_gross_weight' },
      { field: 'driver' },
      { field: 'vehicle' },
      { field: 'route' },
      { field: 'dispatch_date' },
      { field: 'expected_delivery_date' },

    ];
  }

  onInputChange(event: any, field: string) {
    const fieldMapping: { [key: string]: string } = {
      pono: 'status',
      shipmentno: 'name',
      invoice: 'invoice',
      packing_type: 'packing_type',
      total_number: 'total_number',
      total_net_weight: 'total_net_weight',
      total_gross_weight: 'total_gross_weight',
      driver: 'driver',
      vehicle: 'vehicle',
      route: 'route',
      dispatch_date: 'dispatch_date',
      expected_delivery_date: 'expected_delivery_date'
    };

    const inputValue = (event.target as HTMLInputElement).value;
    const dtoField = fieldMapping[field];

    if (this.shipmentSearchDTO && dtoField) {
      (this.shipmentSearchDTO as any)[dtoField] = inputValue;
    }
    this.currentPage=1
    this.fetchData()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }
  }

  toggleContentVisibility(): void {
    this.isContentVisible = !this.isContentVisible;
  }

  onFilterShipmentData() {
    this.filterPoData!.company_code = this.companyCode;
    (this.filterPoData!.plant = this.plant),
      (this.filterPoData!.doc_type = this.docType),
      (this.filterPoData!.doc_cat = this.docCat),
      (this.filterPoData!.poagreement_no = this.poAgreementNo),
      (this.filterPoData!.vendor_code = this.vendorCode),
      (this.filterPoData!.document_date = this.documentDate),
      // this.filterAsnData!.status = this.status,
      (this.filterAsnData!.name = this.shipmentNo),
      (this.filterAsnData!.deliver_from = this.shipmentDeliverFrom);
    this.filterAsnData!.deliver_to = this.shipmentDeliverTo;

    const filterScheduleDate: any = {};
    if (this.documentDate) {
      filterScheduleDate.document_date = this.datePipe.transform(
        this.documentDate,
        'yyyy-MM-dd'
      );
      this.filterPoData!.document_date = filterScheduleDate.document_date;
    }

    const poData = this.getFilteredData(this.filterPoData);
    const AsnData = this.getFilteredData(this.filterAsnData);

    try {
      this.shipmentsASNList
        .getShipmentfilterData(poData, AsnData)
        .then((res) => {
          this.shipmentASNList = res.message;
          if (this.shipmentASNList !== undefined) {
            this.mappedData = this.shipmentASNList.map(
              (shipment: any, index: any) => {
                return {
                  key: `parent_${index}`,
                  data: {
                    shipmentno: shipment.shipmentNo,
                    plant: shipment.vendorCode,
                    pono: shipment.status,
                  },
                  children: shipment.scheduleDeilveries.map(
                    (shipment_data: any, childIndex: any) => {
                      return {
                        key: `child_${index}_${childIndex}`,
                        data: {
                          shipmentno: shipment_data.plant,
                          plant: shipment_data.poagreementNo,
                          pono: this.formatDate(shipment_data.shipmentDate),
                          shipmentdate: shipment_data.name,
                          vcode: shipment_data.itemNo,
                          name: shipment_data.quantity,
                          batchNo: shipment_data.batch_no,
                          quantity: shipment_data.actual_quantity,
                          status: shipment_data.uom,
                          material_code: shipment_data.material_code,
                        },
                      };
                    }
                  ),
                };
              }
            );
          }
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  getFilteredData(filterValidation?: any) {
    const filteredSchiduleData: any = {};
    for (const key in filterValidation) {
      if (filterValidation[key] !== '' && filterValidation[key] !== undefined) {
        filteredSchiduleData[key] = filterValidation[key];
      }
    }
    return filteredSchiduleData;
  }

  initializeColumns2() {
    this.cols2 = [
      { field: 'invoice', header: 'Invoice' },
      { field: 'packing_type', header: 'Packing Type' },
      { field: 'total_number', header: 'Total Number' },
      { field: 'total_net_weight', header: 'Net Weight' },
      { field: 'total_gross_weight', header: 'Gross Weight' },
      { field: 'driver', header: 'Driver' },
      { field: 'vehicle', header: 'Vehicle' },
      { field: 'deliver_from', header: 'Deliver From' },
      { field: 'deliver_to', header: 'Deliver To' },
      { field: 'route', header: 'Route' },
      { field: 'expected_delivery_date', header: 'Expected Delivery Date' },
    ];
  }

  initializeColumns3() {
    this.cols3 = [
      { field: 'shipmentno', header: 'Plant' },
      { field: 'plant', header: 'PO/Agreement No' },
      { field: 'pono', header: 'Delivery Date' },
      { field: 'shipmentdate', header: 'Name' },
      { field: 'vcode', header: 'Item NO	' },
      { field: 'name', header: 'Quantity' },
      { field: 'batchNo', header: 'Batch No' },
      { field: 'quantity', header: 'Batch Quantity	' },
      { field: 'status', header: 'UoM' },
      { field: 'material_code', header: 'Material Code' },
    ];
  }

  onClickASN(rowNode: any) {
    this.selectedASNScheduleDeliveries = [];
    this.sidebarVisible2 = true;

    this.selectedASNNO = rowNode.node.data.shipmentno;
    this.invoiceFileUrl = rowNode.node.data.invoice_document;
    this.eWayBillFileUrl = rowNode.node.data.e_way_bill_document;
    this.iRNBillFileUrl = rowNode.node.data.irn_document;
    this.uploadDocuments.get("invoice_document")?.setValue(this.invoiceFileUrl),
    this.uploadDocuments.get("e_way_bill_document")?.setValue(this.eWayBillFileUrl),
    this.uploadDocuments.get("irn_document")?.setValue(this.iRNBillFileUrl),
    this.initializeColumns2();
    this.initializeColumns3();

    this.shipmentASNService
      .getASNDetail(this.selectedASNNO)
      .then((response: any) => {
        this.selectedASN = response.message;
        this.invoice = response.message[0].invoice;
        this.selectedASNForPdf={
          invoice:this.invoice.split('-')[0],
          packing_type:response.message[0].packing_type,
          total_number:response.message[0].total_number,
          total_net_weight:response.message[0].total_net_weight,
          total_gross_weight:response.message[0].total_gross_weight,
          driver:response.message[0].driver,
          vehicle:response.message[0].vehicle,
          deliver_from:response.message[0].deliver_from,
          deliver_to:response.message[0].deliver_to,
          route:response.message[0].route,
          expected_delivery_date:response.message[0].expected_delivery_date
        }

        this.plantNo = response.message[0].deliver_to;
        this.vendor = response.message[0].vendor;
        this.invoice_callan_no = this.invoice.split('-')[0];

        let filterASN = this.mappedData.filter(
          (item) => item.data.shipmentno === this.selectedASNNO
        );
        filterASN[0].children.forEach(({ data }: { data: any }) => {
          this.selectedASNScheduleDeliveries.push(data);
        });
      })
      .catch((error) => {
        console.error('Error fetching purpose details:', error);
      });


      this.shipmentAsnScheduleList = []
    rowNode.node.children.forEach((schedules:any)=>{
        this.shipmentAsnScheduleDto=new ShipmentAsnSchedule

        this.shipmentAsnScheduleDto.batchNo=schedules.data.batchNo
        this.shipmentAsnScheduleDto.batchQuantity=schedules.data.quantity
        this.shipmentAsnScheduleDto.materialCode=schedules.data.material_code
        this.shipmentAsnScheduleDto.plant=schedules.data.shipmentno
        this.shipmentAsnScheduleDto.poAgreementNo=schedules.data.plant
        this.shipmentAsnScheduleDto.scheduleItemNo=schedules.data.vcode
        this.shipmentAsnScheduleDto.scheduleQuantity=schedules.data.name
        this.shipmentAsnScheduleDto.shipmentDate=schedules.data.pono
        this.shipmentAsnScheduleDto.uom=schedules.data.status
        this.shipmentAsnScheduleDto.vendorName=schedules.data.shipmentdate
        this.shipmentAsnScheduleDto.description_of_material=schedules.data.description_of_material
        this.shipmentAsnScheduleDto.po_line_item=schedules.data.po_line_item

        this.shipmentAsnScheduleList.push(this.shipmentAsnScheduleDto)

    })

    this.shipmentAsnMain!.shipmentNo = rowNode.node.data.shipmentno
    this.shipmentAsnMain!.shipmentAsnScheduleList = this.shipmentAsnScheduleList

  }

  transformKey(key: string): string {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .toUpperCase();
  }

  // async generatePdfWithQRCode() {
  //   const doc = new jsPDF();

  //   // Extract only the 'generated_token_no' field for QR code
  //   const qrText = `ASN No: ${this.selectedASNNO}`;

  //   // Calculate position for QR code in the top-left corner
  //   const qrCodeSize = 30; // Size of the QR code image
  //   const margin = 10; // Margin from the edges of the page
  //   const qrCodeX = margin; // Adjusted position for top-left corner
  //   const qrCodeY = margin; // Adjusted position for top-left corner

  //   // Add QR code to PDF
  //   const qrCodeDataUrl = await QRCode.toDataURL(qrText);
  //   doc.addImage(qrCodeDataUrl, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

  //   // Print Token number next to the QR code
  //   const tokenText = `ASN No: ${this.selectedASNNO}`;
  //   const tokenTextWidth = tokenText.length * 0.12; // Estimation based on font size and text length
  //   const tokenTextX = qrCodeX + qrCodeSize + margin;
  //   const tokenTextY = qrCodeY + qrCodeSize / 2 + 5; // Adjusted vertically to center the text
  //   doc.text(tokenText, tokenTextX, tokenTextY);

  //   // Set starting position for fields below the QR code and token number
  //   let yPos = qrCodeY + qrCodeSize + margin * 2; // Adjusted to leave some space
  //   const lineHeight = 7; // Decreased line height for smaller text
  //   const fieldWidth = 60;

  //   // Set page borders
  //   doc.setDrawColor(0); // Black color
  //   doc.setLineWidth(0.2); // Border width
  //   doc.rect(5, 5, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 10, 'S'); // Draw border around the page

  //   // Add form values to PDF in table form (excluding 'generated_token_no')
  //   doc.setFontSize(10); // Decrease font size
  //   for (const [key, value] of Object.entries(this.selectedASN[0])) {
  //     if (key !== 'generated_token_no') {
  //       const formattedFieldName = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  //       doc.text(`${formattedFieldName}:`, 10, yPos);
  //       doc.text(`${value}`, 80, yPos);
  //       doc.line(10, yPos + 2, doc.internal.pageSize.getWidth() - 10, yPos + 2); // Extend line till the end of the page
  //       yPos += lineHeight;
  //     }
  //   }

  //   // Save the PDF
  //   doc.save('asn.pdf');
  //   // this.createTokenForm.reset();
  // }

  async generatePdfWithQRCode() {
    const doc = new jsPDF();

    // Page 1
    // Extract only the 'generated_token_no' field for QR code
    const qrText = `Advanced Shipping Notice No: ${this.selectedASNNO}`;

    // Calculate position for QR code in the top-left corner
    const qrCodeSize = 30; // Size of the QR code image
    const margin = 10; // Margin from the edges of the page
    const qrCodeX = margin; // Adjusted position for top-left corner
    const qrCodeY = margin; // Adjusted position for top-left corner

    // Add QR code to PDF
    const qrCodeDataUrl = await QRCode.toDataURL(qrText);
    doc.addImage(qrCodeDataUrl, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

    // Print Token number next to the QR code
    const tokenText = `Advanced Shipping Notice`;
    const tokenTextWidth = tokenText.length * 0.12; // Estimation based on font size and text length
    const tokenTextX = qrCodeX + qrCodeSize + margin;
    const tokenTextY = qrCodeY + qrCodeSize / 2 + 5; // Adjusted vertically to center the text
    doc.text(tokenText, tokenTextX, tokenTextY);

    // Set starting position for fields below the QR code and token number
    let yPos = qrCodeY + qrCodeSize + margin * 2; // Adjusted to leave some space
    const lineHeight = 7; // Decreased line height for smaller text
    const fieldWidth = 60;

    // Set page borders
    doc.setDrawColor(0); // Black color
    doc.setLineWidth(0.2); // Border width
    doc.rect(5, 5, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 10, 'S'); // Draw border around the page

    // Add form values to PDF in table form (excluding 'generated_token_no')
    doc.setFontSize(10); // Decrease font size
    for (const [key, value] of Object.entries(this.selectedASNForPdf)) {
      if (key !== 'generated_token_no') {
        const formattedFieldName = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        doc.text(`${formattedFieldName}:`, 10, yPos);
        doc.text(`${value}`, 80, yPos);
        doc.line(10, yPos + 2, doc.internal.pageSize.getWidth() - 10, yPos + 2); // Extend line till the end of the page
        yPos += lineHeight;
      }
    }

    // Add new page for the table
    // doc.addPage();

    // Set start position for table
    const startY = 150;

    // Table code
    autoTable(doc, {
      head: [
        [
          'Plant',
          'PO No',
          'Delivery Date',
          'Name',
          'Item NO',
          'Qty',
          'Batch No',
          'Batch Quantity',
          'UoM',
          'Material Code',
        ],
      ],
      body: this.selectedASNScheduleDeliveries.map((row) =>
        this.cols3.map((col) => row[col.field])
      ),
      startY: startY,
      theme: 'striped',
      styles: { cellPadding: 3, fontSize: 7, halign: 'left' },
      headStyles: { halign: 'left' },
      didParseCell: function (data: any) {
        let text = typeof data.cell.text === 'string' ? data.cell.text : '';
        let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1;
        if (doc.internal.pageSize.width < colWidth + 20) {
          doc.internal.pageSize = {
            width: colWidth + 25,
            getWidth: () => colWidth + 25,
            height: doc.internal.pageSize.height,
            getHeight: () => doc.internal.pageSize.height,
          };
        }
      },
    });

    // Save the PDF
    doc.save('asn.pdf');
    // this.createTokenForm.reset();
  }


  exportPdf() {
    let startY = 75;
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default('p', 'pt');

        autoTable(doc, {
          body: this.selectedASN.reduce((acc: any[], item: any) => {
            Object.entries(item).forEach(([key, value]) => {
              let valueString =
                value !== null && value !== undefined ? value.toString() : '';
              let readableKey = this.transformKey(key);
              acc.push([readableKey, valueString]);
            });
            return acc;
          }, []),
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 4, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1;
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height,
              };
            }
          },
        });

        const rowCount1 = this.selectedASN.length;
        const lineHeight = 12;
        const tableHeight1 = rowCount1 * lineHeight * 200;
        startY += tableHeight1 + 400;

        let header = 'Schedule Deliveries';
        autoTable(doc, {
          head: [
            [
              'Plant',
              'PO/Agreement No',
              'Delivery Date',
              'Name',
              'Item NO',
              'Qty',
              'UoM',
              'Material Code',
            ],
          ],
          body: this.selectedASNScheduleDeliveries.map((row) =>
            this.cols3.map((col) => row[col.field])
          ),
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 3, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1;
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height,
              };
            }
          },
        });

        doc.save('products.pdf');
      });
    });
  }

  exportExcel() {
    import('xlsx').then((xlsx) => {
      const worksheet1 = xlsx.utils.json_to_sheet(this.selectedASN);
      const worksheet2 = xlsx.utils.json_to_sheet(
        this.selectedASNScheduleDeliveries
      );

      const workbook = {
        Sheets: {
          selectedASN: worksheet1,
          selectedASNScheduleDeliveries: worksheet2,
        },
        SheetNames: ['selectedASN', 'selectedASNScheduleDeliveries'],
      };

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, 'products');
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  showDialog2() {
    this.visible = true;
  }
  cancelInvoiceUpload() {
    this.invoiceFile = null; // Assuming you have a variable to store the uploaded file
    this.uploadDocuments.patchValue({
      invoice_document: '',
    });
  }

  cancelEWayBillUpload() {
    this.eWayBillFile = null;
    this.uploadDocuments.patchValue({
      e_way_bill_document: '',
    }); // Assuming you have a variable to store the uploaded file
  }

  cancelIRNUpload() {
    this.iRNBillFile = null; // Assuming you have a variable to store the uploaded file
    this.uploadDocuments.patchValue({
      irn_document: '',
    });
  }

  onInvoiceUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.invoiceFile = file;
      this.invoiceFile = $event.files[0];

      const fileUrl = `/private/files/${this.invoiceFile?.name}`;

      this.uploadDocuments.patchValue({
        invoice_document: fileUrl,
      });
      this.isFileUploaded = true;
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Image uploaded successfully' });
    } else {
      console.error('Please select an MSME certificate.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select an Vendor Image.',
      });
    }
  }

  onEWayBillUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.eWayBillFile = file;
      this.eWayBillFile = $event.files[0];

      const fileUrl = `/private/files/${this.eWayBillFile?.name}`;

      this.uploadDocuments.patchValue({
        e_way_bill_document: fileUrl,
      });
      this.isFileUploaded = true;
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Image uploaded successfully' });
    } else {
      console.error('Please select an MSME certificate.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select an Vendor Image.',
      });
    }
  }

  onIRNBillUpload($event: any) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      this.iRNBillFile = file;
      this.iRNBillFile = $event.files[0];

      const fileUrl = `/private/files/${this.iRNBillFile?.name}`;

      this.uploadDocuments.patchValue({
        irn_document: fileUrl,
      });
      this.isFileUploaded = true;
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Image uploaded successfully' });
    } else {
      console.error('Please select an MSME certificate.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select an Vendor Image.',
      });
    }
  }

  FRAPPE_API_URL = environment.FRAPPE_API_URL;

  onUplosdDocuments() {
    this.visible = false;
    this.uploadDocuments.value.asn_no = this.selectedASNNO;
    const formValues = this.uploadDocuments.value;
    const uploadPromises = [];
    if (this.invoiceFile) {
      const invoiceFileUploadDocuments = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.invoiceFile.name}`,
        doctype: 'Shipment ASN',
        docname: this.uploadDocuments.value.invoice_document,
        fieldname: 'invoice_document',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.invoiceFile, invoiceFileUploadDocuments)
          .toPromise()
      );
    }
    if (this.eWayBillFile) {
      const eWayBillFileUploadDetails = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.eWayBillFile.name}`,
        doctype: 'Shipment ASN',
        docname: this.uploadDocuments.value.e_way_bill_document,
        fieldname: 'e_way_bill_document',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.eWayBillFile, eWayBillFileUploadDetails)
          .toPromise()
      );
    }
    if (this.iRNBillFile) {
      const iRNBillFileUploadDetails = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.iRNBillFile.name}`,
        doctype: 'Shipment ASN',
        docname: this.uploadDocuments.value.irn_document,
        fieldname: 'irn_document',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.iRNBillFile, iRNBillFileUploadDetails)
          .toPromise()
      );
    }
    this.upluadDocumentsASN = {
      asn_no: formValues.asn_no,
      invoice_document: formValues.invoice_document,
      e_way_bill_document: formValues.e_way_bill_document,
      irn_document: formValues.irn_document,
    };
    this.shipmentASNService
      .upload_documents_to_shipment_asn(this.upluadDocumentsASN)
      .then((response: any) => {
        // const message = response.message;
        // const severity = message.status === 'Success' ? 'success' : 'error';
        if(response.message.status == "Failed"){
          this.messageService.add({ severity: 'error', summary: 'Failed', detail:response.message.message});
        }else{
          this.messageService.add({ severity: 'success', summary: 'Successful', detail:response.message.message });
          this.sidebarVisible2 = false
          this.fetchData()
        }
        // this.messageService.add({
        //   severity: 'success',
        //   summary: severity === 'success' ? 'Success' : 'Error',
        //   detail: message.message,
        // });
        this.clearUploads();
        this.uploadDocuments.reset();
      })
      .catch((error) => {
        console.error('Error fetching purpose details:', error);
        console.log(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while creating the delivery schedule.',
        });
        this.uploadDocuments.reset();
      });
  }
  clearUploads() {
    // Reset all file variables to null
    this.invoiceFile = null;
    this.eWayBillFile = null;
    this.iRNBillFile = null;

    // Reset form values
    this.uploadDocuments.reset();

    // Show success message
    // this.messageService.add({
    //   severity: 'success',
    //   summary: 'Success',
    //   detail: 'Uploads cleared successfully.',
    // });
  }

  getSeverity(status: string): string {
    if (!status) {
      return 'info';
    }

    switch (status) {
      case 'Open':
        return 'openforSchedule';
      case 'Open for Schedule':
        return 'openforSchedule';
      case 'Open for Delivery':
        return 'openforDelivery';
      case 'Partial Delivered':
        return 'partialDelivered';
      case 'Delivered':
        return 'delivered';
      case 'Pending For Delivery':
        return 'pendingfordelivery';
      case 'Shipment Delivered':
        return 'shipmentdelivered';
      default:
        return 'info';
    }
  }

  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'openforSchedule':
        return 'openforSchedule';
      case 'openforDelivery':
        return 'openforDelivery';
      case 'partialDelivered':
        return 'partialDelivered';
      case 'delivered':
        return 'delivered';
      case 'pendingfordelivery':
        return 'pendingfordelivery';
      case 'shipmentdelivered':
        return 'shipmentdelivered';
      default:
        return '';
    }
  }
  downloadShipmentExcel(){
    this.shipmentASNService.download_shipment_excel(this.shipmentAsnMain).then((response)=>{

      const fileContent = response.filecontent; // Assuming 'filecontent' is the property containing the file content

        const blob = new Blob([new Uint8Array(fileContent)], {
          type: 'application/octet-stream'
        });

        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'updated_excel.xlsx';

        // Append the download link to the body and trigger the click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Cleanup
        document.body.removeChild(downloadLink);
    }).catch((error)=>{
      console.log(error)
    })
  }

  downloadFile(url: string, fileName: string): void {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading file:', error));
  }
tokenCreateDialog(){
  const navigationExtras: NavigationExtras = {
    state: {
      asn_no: this.selectedASNNO,
      plant:this.plantNo,
      vendor:this.vendor,
      invoice:this.invoice,
      invoice_callan_no:this.invoice_callan_no,
    }
  };
  this.router.navigate(['/token'],navigationExtras);
}
}
